import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { OAuthService } from '@shared/service/auth/o-auth.service';
import { map } from 'rxjs/operators';

import { buildUserRegistrationPrefill, UserRegistrationPrefill } from './user-registration-prefill';

export const userRegistrationPrefillResolver: ResolveFn<UserRegistrationPrefill> = () => {
  const oAuthService = inject(OAuthService);

  return oAuthService
    .getIdTokenClaims$()
    .pipe(map((claims) => buildUserRegistrationPrefill(claims, oAuthService.getActiveAccount())));
};
